import { render } from "./DemoPreview.vue?vue&type=template&id=6208f33e&scoped=true"
import script from "./DemoPreview.vue?vue&type=script&lang=js"
export * from "./DemoPreview.vue?vue&type=script&lang=js"

import "./DemoPreview.vue?vue&type=style&index=0&id=6208f33e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6208f33e"]])

export default __exports__